<template>
  <div>
    <b-modal id="modalEditBuildings" ref="modalEditBuildings" :title="$t('building')" hide-footer>
      <div v-if="editItem">
        <b-form-group label-align="right" label='ID' label-cols="4" label-cols-xl="4" label-cols-md="4" v-if="editItem.house_id">
          <b-form-input type="text" disabled v-model="editItem.house_id"/>
        </b-form-group>
        <b-form-group label-align="right" :label="$t('Connected on')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-input type="date" v-model="editItem.connect_date"/>
        </b-form-group>
        <b-form-group label-align="right" :label="$t('Zip code')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-input type="text" v-model="editItem.post_code"/>
        </b-form-group>
        <b-form-group label-align="right" :label="$t('Country')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-input type="text" v-model="editItem.country"/>
        </b-form-group>
        <b-form-group label-align="right" :label="$t('Province/State')" label-cols="4" label-cols-xl="4" label-cols-md="4">
        <b-form-input type="text" v-model="editItem.region"/>
        </b-form-group>
        <b-form-group label-align="right" :label="$t('City')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-input type="text" v-model="editItem.city"/>
        </b-form-group>
        <b-form-group label-align="right" :label="$t('Street')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-input type="text" v-model="editItem.street"/>
        </b-form-group>
        <b-form-group label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-input-group>
            <b-form-select :options="readyStreets" v-model="curStreet"/>
            <b-input-group-append>
              <b-button @click="addSteet">{{ $t('Add') }}</b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
        <b-form-group label-align="right" :label="$t('Building#')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-input type="text" v-model="editItem.number"/>
        </b-form-group>
        <b-form-group label-align="right" :label="$t('Constr.#')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-input type="text" v-model="editItem.building"/>
        </b-form-group>
        <b-form-group label-align="right" :label="$t('IP zones')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-button class="mb-1" variant="success" size="sm" style="float: right; width: 100px" @click="showModalIpZones">{{ $t('Add') }}</b-button>
        </b-form-group>
        <b-table striped hover small
            :items="editItem.tableIpZones"
            :fields="tableIpZonesFields">
            <template v-slot:cell(actions)="row">
              <b-button size="sm" @click.stop="ClickOnDeleteIpZonesButton(row)" id="transparent">
                <b-img :src='deleteImage'/>
              </b-button>
          </template>
        </b-table>
        <b-row>
          <b-col>
            <b-button class="mt-3" variant="success" style="float: right; width: 100px" @click="save">{{ $t('Save') }}</b-button>
          </b-col>
          <b-col sm="1.5">
            <b-button class="mt-3" variant="secondary" style="float: right; width: 100px" @click="$refs.modalEditBuildings.hide">{{ $t('Cancel') }}</b-button>
          </b-col>
        </b-row>
      </div>
    </b-modal>

    <b-modal hide-footer ref="modalIpZones" id="modalIpZones" :title="$t('IP zones')">
      <b-table striped hover small
        :items="this.$store.getters['ReferenceBooks/IP_ZONES']"
        :fields="fieldsIpZones"
        selectable
        select-mode="single"
        @row-clicked="rowClickIpZones"/>
      <b-row>
        <b-col>
          <b-button class="mt-3" variant="success" style="float: right; width: 100px" @click="addIpZones">Ok</b-button>
        </b-col>
        <b-col sm="1.5">
          <b-button class="mt-3" variant="secondary" style="float: right; width: 100px" @click="$bvModal.hide('modalIpZones')">{{ $t('Cancel') }}</b-button>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
export default {
  props: {
    editItem: null
  },
  data () {
    return {
      curStreet: 1,
      selectedIpZones: null,
      fieldsIpZones: [
        {key: 'id', label: 'ID', sortable: true},
        {key: 'name', label: this.$i18n.t('Name'), sortable: true}
      ],
      tableIpZonesFields: [
        {key: 'id', label: 'ID', sortable: true},
        {key: 'name', label: this.$i18n.t('Name'), sortable: true},
        {key: 'actions', label: this.$i18n.t('Actions'), sortable: true}
      ],
      deleteImage: require('@/assets/img/document_delete.png')
    }
  },
  methods: {
    addSteet () {
      for (let el of JSON.parse(JSON.stringify(this.$store.getters['ReferenceBooks/STREETS']))) {
        if (this.curStreet === el.street_id) {
          this.editItem.country = el.country
          this.editItem.region = el.region
          this.editItem.city = el.city
          this.editItem.street = el.street
        }
      }
    },
    showModalIpZones () {
      this.$refs.modalIpZones.show()
      this.selectedIpZones = null
    },
    rowClickIpZones (row) {
      this.selectedIpZones = row
    },
    ClickOnDeleteIpZonesButton (row) {
      this.editItem.tableIpZones = this.editItem.tableIpZones.filter((value) => {
        return value !== row.item
      })
    },
    addIpZones () {
      if (this.selectedIpZones) {
        for (let el of this.editItem.tableIpZones) {
          if (this.selectedIpZones.id === el.id) {
            this.$root.$emit('makeToasts', 'danger', this.$i18n.t('This IP zone is already in use'), 'Error')
            return
          }
        }
        this.editItem.tableIpZones.push(this.selectedIpZones)
        this.$refs.modalIpZones.hide()
      } else {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Select IP zone'), 'Error')
      }
    },
    save () {
      if (!this.editItem.tableIpZones.length) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('IP zones table is empty'), 'Error')
        return
      }

      this.editItem.connect_date = Number(Date.parse(this.editItem.connect_date)) / 1000
      this.editItem.ip_zones = this.editItem.tableIpZones
      let response = this.editItem.house_id !== 0
        ? this.$store.dispatch('ReferenceBooks/UPDATE_BUILDINGS', this.editItem)
        : this.$store.dispatch('ReferenceBooks/CREATE_BUILDINGS', this.editItem)
      response.then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
        } else {
          setTimeout(this.$store.dispatch, 500, 'ReferenceBooks/GET_BUILDINGS')
          this.$refs.modalEditBuildings.hide()
          this.$root.$emit('makeToasts')
        }
      })
    }
  },
  computed: {
    readyStreets () {
      let tmp = []
      for (let el of this.$store.getters['ReferenceBooks/STREETS']) {
        let newEl = {
          text: '',
          value: 0
        }
        newEl.value = el.street_id
        newEl.text = el.country + ',' + el.region + ',' + el.city + ',' + el.street
        tmp.push(newEl)
      }
      return tmp
    }
  },
  watch: {
    readyStreets: function (val) {
      if (this.readyStreets.length > 0) {
        this.curStreet = this.readyStreets[0].value
      } else {
        this.curStreet = 1
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/referenceBook/buildings/editModal.vue